import { Distributor } from './Distributor';

export type AddDistributor = Omit<Distributor, 'id'>;

export const defaultAddDistributor: AddDistributor = {
    name: '',
    email: '',
    notes: '',
};
